import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';
import { defineComponent, watch, computed } from 'vue';
export default defineComponent({
    props: {
        input: {
            type: String,
            default: '',
        },
        showErrors: {
            type: Boolean,
        },
    },
    emits: ['is-valid-password'],
    setup(props, { emit }) {
        const watchInput = () => {
            emit('is-valid-password', isValidPassword.value);
        };
        watch(() => props.input, watchInput);
        const minLengthRegex = /.{8,}/;
        const uppercaseRegex = /[A-Z]/;
        const lowercaseRegex = /[a-z]/;
        const numberRegex = /\d/;
        const hasMinCharacters = computed(() => validateInput(props.input, minLengthRegex));
        const hasUpperCase = computed(() => validateInput(props.input, uppercaseRegex));
        const hasLowerCase = computed(() => validateInput(props.input, lowercaseRegex));
        const hasNumber = computed(() => validateInput(props.input, numberRegex));
        const isValidPassword = computed(() => hasMinCharacters.value && hasUpperCase.value && hasLowerCase.value && hasNumber.value);
        const validClass = (isValid) => {
            if (isValid) {
                return 'valid';
            }
            if (!props.showErrors) {
                return '';
            }
            return 'invalid';
        };
        const icon = (isValid) => {
            if (!props.showErrors) {
                return 'check-circle';
            }
            return isValid ? 'check-circle' : 'close-circle';
        };
        const validateInput = (input, regex) => regex.test(input);
        return {
            t,
            hasMinCharacters,
            hasUpperCase,
            hasLowerCase,
            hasNumber,
            isValidPassword,
            validClass,
            icon,
            validateInput,
            watchInput,
        };
    },
});
